import { getPricingHolidayByIdRequest } from "../../data/pricingHolidayApi";

function getPayloadData(response) {
  if (response?.data?.data) {
    return response.data.data;
  }

  if (response?.data) {
    return response.data;
  }

  return response;
}

export async function getPricingHolidayByIdUseCase(id) {
  return getPayloadData(await getPricingHolidayByIdRequest(id));
}
